import React from 'react';

import i18n from 'i18next';

import PublishLocalesModal from '../components/publishLocalesModal';

export default ({
  locale,
  locales,
  handlePublishLocales,
  publishedAt,
  isPublished,
  updatedAt,
  status,
  hasUnpublishedChanges,
}) => ({
  body: i18n.t('publish-content-body'),
  component: (
    <PublishLocalesModal
      locale={locale}
      locales={locales}
      handlePublishLocales={handlePublishLocales}
      publishedAt={publishedAt}
      isPublished={isPublished}
      updatedAt={updatedAt}
      status={status}
      hasUnpublishedChanges={hasUnpublishedChanges}
    />
  ),
  hasCloseButton: true,
  title: i18n.t('publish-content'),
});
